import { useMutation } from "@tanstack/react-query";
import {
  createVariantAPI,
  deleteVariantAPI,
  updateVariantAPI,
} from "./variant.api";
import { handleNetworkError } from "@repo/ui/libs";

const useAddVariantMutation = () => {
  return useMutation({
    mutationFn: createVariantAPI,
    onError: handleNetworkError,
  });
};

const useUpdateVariantMutation = () => {
  return useMutation({
    mutationFn: updateVariantAPI,
    onError: handleNetworkError,
  });
};

const useDeleteVariantMutation = () => {
  return useMutation({
    mutationFn: deleteVariantAPI,
    onError: handleNetworkError,
  });
};

export {
  useAddVariantMutation,
  useUpdateVariantMutation,
  useDeleteVariantMutation,
};
